import useSWR from "swr";

export interface Session {
  id: string;
  name: string;
  email: string;
  company: string | null;
  terms_accepted_at: string | null;
  /** Set server-side after a successful sales follow-up request */
  follow_up_sent_at: string | null;
}

async function fetcher(url: string) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Session fetch failed (${res.status})`);
  return res.json();
}

export function useSession() {
  const { data, error, isLoading, mutate } = useSWR<{ session: Session | null }>(
    "/api/session",
    fetcher,
    { shouldRetryOnError: false },
  );

  return {
    session: data?.session ?? null,
    isLoading,
    error,
    mutate,
  };
}
